import { render, staticRenderFns } from "./MetaDataComponent.vue?vue&type=template&id=30b13f52&"
import script from "./MetaDataComponent.vue?vue&type=script&lang=js&"
export * from "./MetaDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports